import { call, put, select, takeLatest } from 'redux-saga/effects';

import profitItemsService from 'services/profitItemsService';

import { getGroupId } from 'store/session/selectors';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import {
  deleteProfitItem,
  entities,
  formulaEdit,
  types,
  updateProfitItem,
  updateVariable,
} from './actions';
import { getProfitItem, getProfitItemId } from './reducer';

export default function* root() {
  yield takeLatest(types.FORMULA_COMPILE_REQUEST, watchCompileFormula);
  yield takeLatest(types.DELETE_PROFIT_ITEM_REQUEST, watchDeleteProfitItem);
  yield takeLatest(types.UPDATE_PROFIT_ITEM_REQUEST, watchUpdateProfitItem);
  yield takeLatest(types.FORMULA_UPDATE_REQUEST, watchUpdateFormula);
  yield takeLatest(types.UPDATE_VARIABLE_REQUEST, watchUpdateVariable);
}

export function* initProfitItemDetailsPage({ match }) {
  try {
    const profitItemId = match.params.profitItemId;
    const profitItem = yield call(profitItemsService.get, profitItemId);
    yield put(entities.receiveProfitItem({ profitItem }));
  } catch (error) {
    console.error('ERROR WHEN INITIATING PRICING ITEM DETAILS PAGE', error);
  }
}

function* watchCompileFormula(action) {
  const { formula } = action.payload;
  const supplierId = yield select(getGroupId);
  const profitItemDefId = yield select(getProfitItemId);

  try {
    yield call(profitItemsService.compilePricingFormula, {
      formula,
      supplierId,
      profitItemDefId,
    });
    yield put(formulaEdit.compileSuccess());
  } catch (error) {
    yield put(formulaEdit.compileError({ error: getErrorMessage(error) }));
  }
}

function* watchDeleteProfitItem() {
  try {
    const profitItem = yield select(getProfitItem);
    const profitItemId = profitItem.id;
    yield call(profitItemsService.delete, profitItemId);
    history.push('/processes/pricing');
    yield put(deleteProfitItem.success());
  } catch (error) {
    yield put(deleteProfitItem.error({ error: getErrorMessage(error) }));
  }
}

function* watchUpdateProfitItem(action) {
  try {
    const { profitItemId, data } = action.payload;
    const response = yield call(profitItemsService.update, profitItemId, data);
    yield put(updateProfitItem.success({ profitItem: response }));
  } catch (error) {
    yield put(updateProfitItem.error(error));
  }
}

function* watchUpdateFormula(action) {
  try {
    const { formula, revertedFrom } = action.payload;
    const profitItemId = yield select(getProfitItemId);

    const nextFormula = yield call(
      profitItemsService.updatePricingFormula,
      profitItemId,
      formula,
      revertedFrom,
    );
    const profitItem = yield call(profitItemsService.get, profitItemId);

    yield put(formulaEdit.updateSuccess({ formula: nextFormula }));
    yield put(entities.receiveProfitItem({ profitItem }));
  } catch (error) {
    yield put(formulaEdit.updateError({ error: getErrorMessage(error) }));
  }
}

function* watchUpdateVariable(action) {
  try {
    const { data, variableId } = action.payload;
    const response = yield call(
      profitItemsService.updateVariable,
      variableId,
      data,
    );
    yield put(updateVariable.success({ variable: response }));
  } catch (error) {
    yield put(updateProfitItem.error(error));
  }
}
